import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import { getResponse, getError } from '@/composables/api'
import axios from 'axios'

export const useDashboardStore = defineStore({
   id: 'dashboard',
   state: () => ({
      counts: [],
      files: [],
      storeAuth: useAuthStore(),
   }),
   actions: {
      getCounts() {
         axios.get('dashboard/counts')
            .then(response => {
               this.counts = getResponse(response)
            })
            .catch(error => {
               console.log(getError(error))
            })
      },
      getFiles() {
         axios.get('dashboard/files')
            .then(response => {
               this.files = getResponse(response)
            })
            .catch(error => {
               console.log(getError(error))
            })
      }
   }
})